<main class="login_wrapper my3" style="height: 100vh; background: aliceblue;">
    <div class="session d-flex justify-content-center">
<div class="div-center">
    <div class="div-center-cn text-center">
        <i class="fa fa-check" aria-hidden="true"></i>
    <h4 class="fw-600">Redirecting..</h4>
</div>
</div>
    </div>
</main>